"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generalInfoSchema = void 0;
const zod_1 = require("zod");
const zodCommon_1 = require("../zodCommon");
exports.generalInfoSchema = zod_1.z
    .object({
    title: zod_1.z
        .string()
        .trim()
        .min(1, 'Required')
        .max(50, 'Only 50 characters are allowed'),
    end_date: zod_1.z.string(),
    start_date: zod_1.z.string(),
    members: zod_1.z.array(zodCommon_1.userSchema).optional(),
    cover_image: zod_1.z.string().optional(),
    website: zod_1.z.string().optional(),
    additionalInfo: zod_1.z.string().optional(),
    OSMAddress: zod_1.z.any().optional(),
    additionFiles: zodCommon_1.documentsTransformer,
})
    .catchall(zod_1.z.any());
